<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{
          $t("CRUD.chooseInfo", [
            $t("SortingOutSetting.super_sorting_users.user"),
          ])
        }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="8" md="6">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="name"
              v-model="keyword"
              @text="Keyword = $event"
              :label="$t('AccountUser.keyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" md="6" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.actions="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex mt-n2 mb-n3 justify-center">
            <v-btn
              color="primary"
              dense
              @click="
                $emit('confirm', item);
                dialog = false;
              "
              :disabled="item.disabled"
            >
              {{
                item.choose
                  ? $t("Shop.Fields.selected")
                  : $t("Shop.Fields.choose")
              }}
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption"> </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import AccountUsers from "@/api/account_users";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "DialogAccountUser",

  props: {
    value: Boolean,
    disabled: Array,
    userChoosed: Array,
    usersIdDisabled: Array,
  },

  components: { SearcherKeyword },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("SmsPushSetting.TableTitle.organization"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "organization.name",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.role"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "role.role_name",
        },
        {
          text: i18n.t("SortingOutSetting.super_sorting_users.staff_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("SortingOutSetting.super_sorting_users.select"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    users: [],
    itemsPerPageOptions: 10,
    fetchTimestamp: 0, //第一次获取商品列表的时间
    userId: [],
    keyword: "",
    Keyword: "",
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.keyword = this.Keyword;
    },

    //获取material列表
    getUsersFromAPI() {
      // if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
      //   this.users = this.users.map((user) => {
      //     if (
      //       this.userId.indexOf(user.id) > -1 &&
      //       (!user.choose || !user.disabled)
      //     ) {
      //       user = Object.assign({}, user, {
      //         choose: 1,
      //         disabled: true,
      //       });
      //     } else if (
      //       this.userId.indexOf(user.id) == -1 &&
      //       (user.choose == 1 || user.disabled)
      //     ) {
      //       if (user.choose == 1) {
      //         user.choose = 0;
      //       }
      //       if (user.disabled) {
      //         user.disabled = false;
      //       }
      //     }

      //     if (this.usersIdDisabled.indexOf(user.id) > -1) {
      //       user = Object.assign({}, user, {
      //         disabled: true,
      //       });
      //     }

      //     return user;
      //   });

      //   return;
      // }
      AccountUsers.fetchAll({ type: 2, keyword: this.keyword }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.users = response.data.account_users.map((user) => {
              //默认勾选
              if (this.userId.indexOf(user.id) > -1) {
                user = Object.assign({}, user, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (user.choose == 1 || !user.choose) {
                  user.choose = 0;
                }
                if (user.disabled) {
                  user.disabled = false;
                }
              }
              if (this.usersIdDisabled.indexOf(user.id) > -1) {
                user = Object.assign({}, user, {
                  disabled: true,
                });
              }
              return user;
            });
            // this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.keyword = "";
          this.dialog = this.value;
          // console.log(this.userChoosed)
          if (this.userChoosed && this.userChoosed.length) {
            this.userId = this.userChoosed.map((user) => {
              return user.id;
            });
          } else {
            this.userId = [];
          }
          this.getUsersFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    users: {
      deep: true,
      handler() {},
    },
    keyword: {
      handler() {
        this.getUsersFromAPI();
      },
    },
  },
};
</script>